import React from 'react';
import PropTypes from 'prop-types';
import { cn } from 'src/lib/utils';

// Horizontal metric tile (icon left, figure + label right) — a summary strip
// for the list below it, not a dashboard hero, so it stays compact. Shared
// between the CSE and TA opportunity-listing summary strips.
const MetricTile = ({
  icon: Icon,
  iconBg,
  iconColor,
  value,
  ofValue,
  label,
  sub,
  barPct,
  wide,
}) => (
  <div
    className={cn(
      'bg-card border border-border rounded-xl px-[14px] py-[12px] flex items-center gap-[11px]',
      wide && 'col-span-2'
    )}
  >
    <div
      className="w-[30px] h-[30px] min-w-[30px] rounded-lg flex items-center justify-center flex-shrink-0"
      style={{ backgroundColor: iconBg }}
    >
      <Icon
        className="w-[15px] h-[15px]"
        strokeWidth={2}
        style={{ color: iconColor }}
      />
    </div>
    <div className="min-w-0 flex-1">
      <div className="flex items-baseline gap-1.5">
        <span className="text-[21px] font-bold leading-[1.15] tracking-[-0.02em] text-foreground-strong tabular-nums">
          {value}
        </span>
        {ofValue != null && (
          <span className="text-[13px] font-semibold text-muted-foreground">
            of {ofValue}
          </span>
        )}
      </div>
      <div className="text-[11.5px] text-muted-foreground leading-[1.3]">
        {label}
      </div>
      {sub && (
        <div className="text-[11px] text-foreground-muted leading-[1.3] mt-px">
          {sub}
        </div>
      )}
      {barPct != null && (
        <div className="h-1 rounded-full bg-muted overflow-hidden mt-1.5">
          <div
            className="h-full rounded-full bg-primary"
            style={{ width: `${Math.min(100, barPct)}%` }}
          />
        </div>
      )}
    </div>
  </div>
);

MetricTile.propTypes = {
  icon: PropTypes.elementType.isRequired,
  iconBg: PropTypes.string.isRequired,
  iconColor: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  ofValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string.isRequired,
  sub: PropTypes.string,
  barPct: PropTypes.number,
  wide: PropTypes.bool,
};

// eslint-plugin-react's require-default-props (via airbnb) wants
// defaultProps, not destructuring defaults — matches the existing
// SearchInput.jsx convention in this folder.
MetricTile.defaultProps = {
  ofValue: null,
  sub: null,
  barPct: null,
  wide: false,
};

export default MetricTile;
